<template>
	<div class="label" v-if="!allignLabel && field.label">
		<ion-label>{{ field.label }}</ion-label>
	</div>
	<div :class="{input: !allignLabel, inputLabel: allignLabel}">
		<ion-label class="ion-align-self-center" v-if="allignLabel && field.label">{{ field.label }}</ion-label>
		<ion-checkbox
		:class="{defaultBorder: validationState == null || !enabled, invalidBorder: enabled && validationState == false, validBorder: enabled && validationState == true}"
			v-model="field.value"
			ref="check"
			:disabled="!field.enabled"
			slot="end"
			@ionChange="detectCheckboxChange">
		</ion-checkbox>
		<ion-button class="ion-align-self-center" slot="end" fill="clear" v-if="canUnlock" @click="changeLockState">
			<ion-icon slot="icon-only" v-if="!field.enabled" :icon="lockOpenOutline"></ion-icon>
			<ion-icon slot="icon-only" v-else :icon="lockClosedOutline"></ion-icon>
		</ion-button>
	</div>
</template>

<style scoped>
	* {
		--padding-bottom:	0px;
		--padding-top:	0px;
		/*margin-right: .5em;*/
	}
	ion-item {
		--padding-start: 0;
		--padding-end: 0;
	}
	ion-icon {
		margin-right: 0;
	}
	ion-button {
		--padding-start: 0;
		--padding-end: 0;
	}
	ion-label {
		font-weight: bold;
		/*margin-top: .7em;*/
	}
	ion-checkbox::part(container) {
		border-radius: 5px !important;
		border: 1px solid  var(--ion-color-light-shade);
	}
	.defaultBorder {
		border: 1px solid var(--ion-color-light-shade) !important;
	}
	.invalidBorder {
		border: 1px solid red !important;
	}
	.validBorder {
		border: 1px solid green !important;
	}
	.label {
		margin-top: .5em;
		margin-left: .5em;
	}
	.input {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		text-align: left;
		margin-left: .5em;
		margin-right: .5em;
	}
	.inputLabel {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		text-align: left;
		margin-top: .5em;
		margin-left: .5em;
		margin-right: .5em;
	}
</style>

<script>
import { IonButton, IonIcon, IonCheckbox, IonLabel } from '@ionic/vue';
import { lockClosedOutline, lockOpenOutline } from "ionicons/icons";
import { defineComponent } from "vue";

	export default defineComponent({
		props: {
			label: { type: String, default: "Label" },
			allignLabel: { type: Boolean, default: false },
			required: { type: Boolean, default: true },
			value: { /*type: Boolean, */ default: null },
			enabled: { type: Boolean, default: true },
			validationState: { type: Boolean, default: null },
			canUnlock: { type: Boolean, default: false },
		},
		components: {
			IonLabel,
			IonCheckbox,
			IonButton,
			IonIcon,
		},
		emits: [ "checkboxChanged" ],
		data: () => ({
			field: {
				label: null,
				value: null,
				enabled: true,
			},
			lockOpenOutline,
			lockClosedOutline,
		}),
		mounted () {
			this.field.label = (!this.label) ? this.label : ((!this.required) ? this.label : this.label + "*");
			this.field.value = this.value;
			this.field.enabled = this.enabled;
		},
		watch: {
			label () {
				this.field.label = (!this.label) ? this.label : ((!this.required) ? this.label : this.label + "*");
			},
			value () {
				this.field.value = this.value;
			},
			enabled () {
				this.field.enabled = this.enabled;
			},
  },
		methods: {
			detectCheckboxChange() {
				setTimeout(() => this.emitChanges(), 0);
			},
			emitChanges() {
				this.$emit('checkboxChanged', this.field.value);
			},
			changeLockState() {
				this.field.enabled = !this.field.enabled;
			},
		}
	});
</script>
